import React, { useEffect, useState } from "react";
import RegisterTitle from "../../components/CommonTitle";
import intervals from "../../assets/icons/intervals.webp";
import SeasonMainCard from "../../components/season/SeasonMainCard";
import { MdAdd, MdDeleteOutline } from "react-icons/md";
import {
  createSeason,
  getSeasons,
  createDefaultBlocksAndRelateToSeason,
  deleteSeason,
  getSeasonsByPage,
} from "../../services/seasons";
import LoadingPage from "../../components/LoadingPage";
import ModalStructure from "../../components/ModalStructure";
import { useNavigate } from "react-router-dom";
import {
  getNextDay,
  getNextDayByStr,
  getPeruISOStringAtEnd,
  getPeruISOStringAtZero,
} from "../../utils/timeFuncs";
import Pagination from "../../components/Pagination";
import { IS_LOCAL_ENV } from "../../App";
import Notification from "../../components/ui-elements/Notification";

// const seasonsInfo = [
//   {
//     seasonNumber: "1",
//     initDate: "2 de septiembre",
//     endDate: "02 de Octubre",
//   },
//   {
//     seasonNumber: "2",
//     initDate: "2 de septiembre",
//     endDate: "02 de Octubre",
//   },
//   {
//     seasonNumber: "3",
//     initDate: "2 de septiembre",
//     endDate: "02 de Octubre",
//   },
//   {
//     seasonNumber: "4",
//     initDate: "2 de septiembre",
//     endDate: "02 de Octubre",
//   },
// ];

const Seasons = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [seasons, setSeasons] = useState([]);
  const [creating, setCreating] = useState(false);
  const [showModal, setShowModal] = useState(false);
  //==============primera temoirada====================
  const [isFirstSeason, setIsFirstSeason] = useState(false);
  const [initDate, setInitDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [seasonToDelete, setSeasonToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [totalDocs, setTotalDocs] = useState(1);
  //==============pagination props =====================
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  //las temporadas se traen en orden descendente por fecha final
  //por lo que el primer elemento en el array seasons es la última temporada
  const getLastSeason = (arr) => arr[0];
  const addSeason = (obj, arr) => [obj, ...arr]; //pushfront

  useEffect(() => {
    const fetchSeasons = async () => {
      setLoading(true);
      try {
        const response = await getSeasonsByPage(currentPage);
        setTotalDocs(response.totalDocs);
        setTotalPages(response.totalPages);
        //setCurrentPage(response.page);
        // Validamos si response.docs existe y es un arreglo
        const docs = Array.isArray(response?.docs) ? response.docs : [];

        setSeasons(docs); // Si no existe o es vacío, se establece un arreglo vacío
        setIsFirstSeason(docs.length === 0); // Primera temporada si no hay docs

        if (docs.length > 0) {
          // Obtener la última fecha de la última temporada si hay temporadas
          const lastDate = getNextDay(getLastSeason(docs).endDate);
          setInitDate(lastDate);
        }

        setLoading(false);
      } catch (err) {
        Notification({
          title: "Error",
          text: `Algo salió mal...`,
          type: "Error",
        });
        navigate("/home");
      }
    };
    fetchSeasons();
    //IS_LOCAL_ENV && console.log(params["*"]);
  }, [currentPage]);

  const onClickAddSeason = () => {
    if (!initDate || !endDate) {
      Notification({
        title: "Error",
        text: `Debes seleccionar una fecha de inicio y fin`,
        type: "Error",
      });
      return;
    } else if (
      seasons.length > 0 &&
      getLastSeason(seasons)?.status != "published"
    ) {
      Notification({
        title: "Error",
        text: `Aún no se ha publicado la última temporada`,
        type: "Error",
      });
      return;
    } else {
      const handleCreateSeason = async () => {
        try {
          setCreating(true);
          //crear temporada y crear 4 bloques por defecto
          //los objetos season se reciben ordenados ascendentemente por fecha final
          //al crear una nueva temporada, esta se debe crear un dia despues de la fecha final de la ultima temporada

          const newSeasonInitDate = getPeruISOStringAtZero(initDate); // Fecha inicial
          const newSeasonLastDate = getPeruISOStringAtEnd(endDate); // Fecha final
          const newSeasonNumber = isFirstSeason
            ? 1
            : parseInt(getLastSeason(seasons).number) + 1;
          const props = {
            name: `Temporada ${newSeasonNumber}`,
            number: newSeasonNumber,
            initDate: newSeasonInitDate,
            endDate: newSeasonLastDate,
            status: "hidden",
          };

          IS_LOCAL_ENV && console.log(props);
          const newSeason = await createSeason(props);
          const newBlocks = await createDefaultBlocksAndRelateToSeason(
            newSeason.id,
            newSeasonInitDate,
            newSeasonLastDate
          );
          const s = [newSeason, ...seasons];
          setSeasons(s);
          //===========Resetear props=========================
          setIsFirstSeason(false);
          setInitDate(getNextDay(newSeasonLastDate)); //siguiente dia
          setEndDate(null);
          setCreating(false);
          setShowModal(false);
          Notification({
            title: "Operación completada",
            text: `Se creó la nueva temporada`,
            type: "Success",
          });
          //crear 4 bloques:
        } catch (err) {
          setCreating(false);
          Notification({
            title: "Error",
            text: `Algo salió mal...`,
            type: "Error",
          });
          IS_LOCAL_ENV && console.error(err);
        }
      };
      handleCreateSeason();
    }
  };

  const handleClickDeleteSeason = () => {
    if (seasonToDelete) {
      setDeleting(true);
      const handleDeleteSeason = async () => {
        try {
          const { message } = await deleteSeason(seasonToDelete.season);
          IS_LOCAL_ENV && console.log(message || "");
          //eliminar del array
          let temp = [...seasons];
          temp.splice(seasonToDelete.pos, 1);
          if (totalPages == 1 && seasons.length == 1) {
            //si solo hay una temporada y es la primera:
            setIsFirstSeason(true);
            setSeasons([]);
            setInitDate(null);
          } else {
            const lastDate = getNextDay(getLastSeason(temp).endDate);
            setInitDate(lastDate);
            setSeasons(temp);
          }
          setEndDate(null);
          setSeasonToDelete(null);
          setDeleting(false);
          setShowDeleteModal(false);
          Notification({
            title: "Operación completada",
            text: `Se eliminó la temporada`,
            type: "Success",
          });
        } catch (err) {
          setDeleting(false);
          Notification({
            title: "Error",
            text: `Algo salió mal...`,
            type: "Error",
          });
          IS_LOCAL_ENV && console.error(err);
        }
      };
      handleDeleteSeason();
    }
  };

  return (
    <div className="w-full flex flex-col h-full items-center">
      <RegisterTitle
        img={intervals}
        title={"Temporadas"}
        text={"Supervisa y añade tantas temporadas como necesites."}
      />
      {loading ? (
        <LoadingPage />
      ) : (
        <div className="w-full gap-y-4 md:my-6 my-4 flex justify-center flex-col items-center">
          {showDeleteModal && (
            <ModalStructure handleCloseModal={() => setShowDeleteModal(false)}>
              <div className="flex flex-col items-center justify-center gap-y-4 my-2 font-poppins">
                <h3 className="font-poppins font-bold text-dark-green text-wrap text-lg">
                  ¿Estás seguro de que quieres eliminar esta temporada?
                </h3>
                <span className="text-default-gray w-full text-center px-4 flex">
                  Esto no puede ser revertido
                </span>

                <button
                  className={` w-fit  text-lg  flex justify-center rounded-full py-2 px-4 text-white m-2 ${
                    deleting
                      ? "bg-default-gray cursor-not-allowed"
                      : "bg-light-purple-600 hover:bg-dark-purple"
                  } transition-all duration-100 font-bold font-poppins `}
                  onClick={handleClickDeleteSeason}
                >
                  <span className="flex flex-row items-center gap-x-2">
                    <span>Eliminar</span>
                    <MdDeleteOutline />
                  </span>
                </button>
              </div>
            </ModalStructure>
          )}
          <div className="max-w-[1280px] w-full flex flex-wrap justify-center ">
            {seasons.map((season, i) => {
              return (
                <SeasonMainCard
                  {...season}
                  key={i}
                  onClickDeleteSeason={() => {
                    setSeasonToDelete({ season: season, pos: i });
                    setShowDeleteModal(true);
                  }}
                  totalDocs={totalDocs}
                />
              );
            })}
          </div>
          {showModal && (
            <ModalStructure
              handleCloseModal={() => setShowModal(false)}
              customMaxW={"max-w-[500px]"}
            >
              <div className="flex flex-col items-center justify-center gap-y-4 my-2 font-poppins">
                <h3 className="font-poppins font-bold text-dark-green text-wrap text-lg">
                  {isFirstSeason
                    ? "Crear primera temporada"
                    : "Crear temporada"}
                </h3>
                {isFirstSeason && (
                  <p className="text-d2efault-gray">
                    Esta será la primera temporada. En adelante, las siguientes
                    temporadas serán creadas automáticamente 1 día después de la
                    fecha fin de la temporada anterior. Deberás establecer la
                    fecha fin una única vez. Asegúrate de establecer
                    correctamente las fechas.
                  </p>
                )}
                <a
                  href={
                    "https://docs.google.com/document/d/1SXg_-qgItK4KfG94PjXYRgoqAdMAUsrhNBJB1iRfp2A/edit?usp=sharing"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  Guia de uso
                </a>
                <span className="font-bold">
                  Selecciona una fecha de inicio:
                </span>
                <input
                  className="rounded-full font-poppins w-[150px]"
                  type="date"
                  min={
                    //si es la primera temporada, la fecha minima inicial es hoy
                    isFirstSeason
                      ? new Date().toLocaleDateString("sv-SE", {
                          timeZone: "America/Lima",
                        })
                      : initDate
                  }
                  value={initDate ? initDate : ""}
                  onChange={(e) => setInitDate(e.target.value)}
                  disabled={!isFirstSeason}
                />
                <span className="font-bold">Selecciona una fecha de fin:</span>
                <input
                  className={`${
                    !initDate ? "text-default-gray" : ""
                  } rounded-full font-poppins w-[150px]`}
                  type="date"
                  min={initDate ? getNextDayByStr(initDate) : ""}
                  value={endDate ? endDate : ""}
                  onChange={(e) => setEndDate(e.target.value)}
                  disabled={!initDate}
                />
                <button
                  className={` w-fit  text-lg  flex justify-center rounded-full py-2 px-4 text-white m-2 ${
                    creating
                      ? "bg-default-gray cursor-not-allowed"
                      : "bg-light-purple-600 hover:bg-dark-purple"
                  } transition-all duration-100 font-bold font-poppins `}
                  onClick={(e) => onClickAddSeason()}
                >
                  <span className="flex flex-row items-center gap-x-2">
                    <span>
                      {creating ? "Creando temporada..." : "Añadir temporada"}
                    </span>
                    <MdAdd />
                  </span>
                </button>
              </div>
            </ModalStructure>
          )}
          {currentPage == 1 &&
            (seasons.length == 0 || seasons[0]?.status == "published") && (
              <button
                className={` w-fit  text-xl  flex justify-center rounded-full py-4 px-8 text-white  ${
                  creating
                    ? "bg-default-gray cursor-not-allowed"
                    : "bg-light-purple-600 hover:bg-dark-purple"
                } transition-all duration-100 font-bold font-poppins `}
                onClick={() => {
                  setShowModal(true);
                }}
              >
                <span className="flex flex-row items-center gap-x-2">
                  <span>
                    {creating ? "Creando temporada..." : "Añadir temporada"}
                  </span>
                  <MdAdd />
                </span>
              </button>
            )}
        </div>
      )}
      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
      />
    </div>
  );
};

export default Seasons;
